// CatTouchUpPreferences.jsx
import React from 'react';

const CatTouchUpPreferences = ({ groomingBookingData, setGroomingBookingData }) => {
  var opts = groomingBookingData && groomingBookingData.groomingOptions ? groomingBookingData.groomingOptions : {};
  var selectedAdditional = opts.additionalServices || [];

  function toggleAdditional(service) {
    var updated = selectedAdditional.slice(0);
    var idx = -1;
    var i = 0;
    while (i < updated.length) {
      if (updated[i] === service) { idx = i; break; }
      i++;
    }
    if (idx >= 0) { updated.splice(idx, 1); } else { updated.push(service); }

    setGroomingBookingData(function(prev){
      var next = Object.assign({}, prev || {});
      var go = next.groomingOptions ? Object.assign({}, next.groomingOptions) : {};
      go.additionalServices = updated;
      next.groomingOptions = go;
      return next;
    });
  }

  function isSelected(service) {
    var i = 0;
    while (i < selectedAdditional.length) {
      if (selectedAdditional[i] === service) return true;
      i++;
    }
    return false;
  }

  function toggleCondition(key) {
    setGroomingBookingData(function(prev){
      var next = Object.assign({}, prev || {});
      var go = next.groomingOptions ? Object.assign({}, next.groomingOptions) : {};
      var current = go[key] ? true : false;
      go[key] = !current;
      next.groomingOptions = go;
      return next;
    });
  }

  function isConditionSelected(key) {
    return groomingBookingData &&
           groomingBookingData.groomingOptions &&
           groomingBookingData.groomingOptions[key] ? true : false;
  }

  var included = [
    'Sanitary Trim',
    'Paws Tidy / Pad Shave',
    'Nail Trim & File',
    'Full Bath & Dry',
    'Brush Out',
    'Ear Cleaning',
    'Paw Balm'
  ];

  var addOns = [
    { key: 'deshedding', label: 'De-Shedding' },
    { key: 'fleaTick',  label: 'Flea & Tick Treatment' }
  ];

  return (
    <div className="touchup-preferences">
      <h3>What’s included for cats?</h3>
      <ul>
        {included.map(function(item, i){ return <li key={i}>{item}</li>; })}
      </ul>

      <h3>Special Conditions</h3>
      <div className="special-conditions">
        <button
          className={'condition-button ' + (isConditionSelected('mattedHair') ? 'selected' : '')}
          onClick={function(){ toggleCondition('mattedHair'); }}
          type="button"
        >
          Matted Hair (De-matting)
        </button>
        <button
          className={'condition-button ' + (isConditionSelected('sensitiveSkin') ? 'selected' : '')}
          onClick={function(){ toggleCondition('sensitiveSkin'); }}
          type="button"
        >
          Sensitive Skin (Hypoallergenic)
        </button>
      </div>

      <h3>Additional Services</h3>
      <div className="additional-services">
        {addOns.map(function(a){
          return (
            <button
              key={a.key}
              className={'service-button ' + (isSelected(a.key) ? 'selected' : '')}
              onClick={function(){ toggleAdditional(a.key); }}
              type="button"
            >
              {a.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CatTouchUpPreferences;
